import Nullstack from 'nullstack';
export default function IconWorld({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-world",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("line", {
    x1: "3.6",
    y1: "9",
    x2: "20.4",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "3.6",
    y1: "15",
    x2: "20.4",
    y2: "15"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 3a17 17 0 0 0 0 18"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 3a17 17 0 0 1 0 18"
  }), " ");
}